import useUser from 'hooks/useUser';
import { FormattedMessage } from 'react-intl';
import PaymentType from 'types/PaymentType';
import * as styles from './styles/styles.module.scss';

type Props = {
  tabs: PaymentType[];
  activeTab: number;
  handler: (index: number) => void;
  showPayWithCard?: boolean;
};

const LinkItem = ({ item, showPayWithCard }: { item: PaymentType; showPayWithCard: boolean }) => {
  const user = useUser();

  const { name, iconPath } = item;

  switch (name) {
    case 'PayPal':
    case 'Apple Pay':
      return (
        <span className={styles.tabIcon}>
          <img alt={name} src={iconPath} />
        </span>
      );
    case 'payByCreditCard':
      return user?.isPromoEligible && !showPayWithCard ? (
        <FormattedMessage defaultMessage="Enter payment details" />
      ) : (
        <FormattedMessage defaultMessage="Pay with card" />
      );
  }
};

const PaymentTabs = ({ tabs, handler, activeTab, showPayWithCard = false }: Props) => {
  const grouped = {} as { [key: string]: JSX.Element[] };
  let tabKey = -1;

  tabs.map(tab => {
    if (!tab.showTab) {
      return;
    }

    tabKey = tab.tab || tabKey + 1;

    if (!grouped[tabKey]) {
      grouped[tabKey] = [];
    }

    return grouped[tabKey].push(<LinkItem key={tab.name} item={tab} showPayWithCard={showPayWithCard} />);
  });

  return (
    <div className={styles.tabBar}>
      {Object.keys(grouped).map((item, index) => (
        <div
          key={index}
          tabIndex={0}
          role="tab"
          className={`${styles.tab} ${index == activeTab ? styles.active : ''}`}
          onClick={() => handler(index)}
          onKeyDown={() => handler(index)}
        >
          {grouped[item]}
        </div>
      ))}
    </div>
  );
};

PaymentTabs.defaultProps = {
  handler: () => {},
  activeTab: 0
};

export default PaymentTabs;
